export const MuiTab = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      fontFamily: 'Sarabun',
      fontSize: '14px',
      lineHeight: '24px',
      fontWeight: 600,
      color: 'rgba(159, 159, 159, 1)',

      '&.Mui-selected': {
        color: 'rgba(34, 40, 34, 1)',
      },
    },
  },
};
